export enum TabEnum {
  program = 'program',
  reviews = 'reviews',
  about = 'about',
  map = 'map',
  gallery = 'gallery',
}
